<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:headers="colunas"
			:items="itens"
			:server-items-length="totalItens"
			item-key="id"
			:options="paginacaoInterna"
			no-data-text="Não há processos de utilização cadastrados"
			hide-default-footer
			class="arp-listview row-pointer"
		>
			<template #item.numeroProcesso="{ item }">
				<span>{{ item.numeroProcesso | semProcessoFilter }}</span>
			</template>

			<template #item.descricao="{ item }">
				<texto-tooltip :texto="item.descricao" :tamanho-maximo="40"></texto-tooltip>
			</template>
			<template #item.fimValidadeAta="{ item }">
				{{ item.fimValidadeAta | formatDataFilter }}
			</template>
			<template #item.orgao="{ item }">
				<span> {{ item.orgao | semProcessoFilter }}</span>
			</template>
			<template #item.situacao="{ item }">
				<span>
					{{ item.situacao }}

					<icone-tooltip
						v-if="item.isBloqueado"
						icone="mdi-cancel"
						cor="red"
						texto="Ata está bloqueada."
						tamanho="16px"
					></icone-tooltip>
				</span>
			</template>
			<template #item.acoes="{ item }">
				<botao-tooltip
					icone="mdi-login"
					cor="grey"
					texto="Acessar"
					@click="acessarProcessoUtilizacao(item)"
				></botao-tooltip>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>

		<template-listagem-vazia :textos="textos" :total-itens="totalItens"></template-listagem-vazia>
	</div>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import tabelaMixin from '@/views/mixins/tabela'
import AtaListagemBotoesAcoes from '@/views/pages/ata/pesquisa/listagem/botoes-acoes/AtaListagemBotoesAcoes.vue'
import { actionTypes } from '@/core/constants'

export default {
	name: 'processo-utilizacao-listagem',
	components: { AtaListagemBotoesAcoes },
	mixins: [tabelaMixin],
	props: {
		itens: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('Nº Ata', 'idAta', '10%'),
				new TabelaColunaUtils('Validade Ata', 'fimValidadeAta', '10%'),
				new TabelaColunaUtils('Nº Processo', 'numero', '15%'),
				new TabelaColunaUtils('Objeto', 'objeto', '20%'),
				new TabelaColunaUtils('Orgão', 'siglaOrgao', '10%'),
				new TabelaColunaUtils('Atividade', 'atividade', '15%'),
				new TabelaColunaUtils('Recebido', 'recebido_fluxo', '5%', 'center'),
				new TabelaColunaUtils('Ações', 'acoes', '5%'),
			],
			paginacaoInterna: this.paginacao,
			textos: {
				titulo: 'Não foram encontrados processos de utilização',
			},
		}
	},

	methods: {
		async acessarProcessoUtilizacao(item) {
			const params = {
				idProcessoUtilizacao: item.id,
				idUnidadeOrganizacional: item.idOrgaoLegado,
			}
			const data = await this.$store.dispatch(
				actionTypes.PROCESSO_UTILIZACAO.BUSCAR_URL_PROCESSO_UTILIZACAO_LEGADO,
				params,
			)
			if (data.url) {
				window.open(data.url)
			}
		},
		resetarPage() {
			this.$emit('resetar-page')
		},
	},
}
</script>

<style scoped lang="stylus">
.pr-tabela-processo-utilizacao-listagem td:hover
	cursor pointer !important

@media (max-width: 720px)
	.pr-tabela-processo-utilizacao-listagem
		td:nth-of-type(1):before
			content "Nº Ata:"

		td:nth-of-type(2):before
			content "Processo:"

		td:nth-of-type(3):before
			content "Descrição:"

		td:nth-of-type(4):before
			content "Órgão Gerenciador:"

		td:nth-of-type(5):before
			content "Situação:"

		td:nth-of-type(6):before
			content "Fim Validade:"

		td:nth-of-type(7):before
			display none
</style>
